/* LPM · Filtres rapides : variante B du test « filtres mobile » (27/10/2026).
   Dossier : Dropbox/claude-cowrok/18_Theme_Ella/filtres-mobile_2026-10-27/ (sources, construction, LISEZ-MOI).
   - Mesure, variantes A et B : événement dataLayer « lpm_ab_filtres » et étiquette Clarity « ab_filtres » sur chaque
     page de collection ; « lpm_filtre » (filtre coché), « lpm_filtre_panneau » (panneau ouvert), « lpm_tri ».
   - Variante B seulement (html.lpm-filtres-b, posé par snippets/lpm-filtres-rapides.liquid), mobile et tablette :
     les puces et le tri cochent le formulaire Ella #CollectionFiltersForm puis appellent CollectionFiltersForm.renderPage
     (collection-filters-form.js, inchangé) ; le panneau Ella est réordonné (Pour qui, Prix, Type, Saison, Couleur,
     Marque, Matière, puis « Filtres supplémentaires » repliés), les filtres utiles sont ouverts, les valeurs brutes
     (« casque-integral ») affichées avec leur libellé, et un pied collant « Réinitialiser / Voir N produits » ferme le panneau. */
(function () {
  'use strict';
  var html = document.documentElement;
  var variante = window.lpmAbFiltres || null;
  var EN = /^en/i.test(html.lang || '');
  var T = EN
    ? { voir: function (n) { return n === 1 ? 'Show 1 product' : 'Show ' + n + ' products'; }, aucun: 'No product: change your filters', maj: 'Updating…', reset: 'Reset', plus: 'More filters' }
    : { voir: function (n) { return n === 1 ? 'Voir 1 produit' : 'Voir ' + n.toLocaleString('fr-FR') + ' produits'; }, aucun: 'Aucun produit : modifiez vos filtres', maj: 'Mise à jour…', reset: 'Réinitialiser', plus: 'Filtres supplémentaires' };
  // Libellés des valeurs canoniques (dictionnaire de la taxonomie du 27/10/2026), par clé de métachamp : slug → libellé.
  var LIBELLES = {"type_produit":{"casque-integral":"Casque intégral","casque-modulable":"Casque modulable","casque-jet":"Casque jet","casque-tout-terrain":"Casque cross / tout-terrain","accessoire-casque":"Accessoire casque","visiere":"Visière / écran","housse-casque":"Housse de casque","support-casque":"Support de casque","intercom":"Intercom","blouson":"Blouson","veste":"Veste","gilet-cuir":"Gilet cuir biker","combinaison-moto":"Combinaison","streetwear":"Veste streetwear","haute-visibilite":"Haute visibilité","veste-pluie":"Veste de pluie","pantalon":"Pantalon","surpantalon":"Surpantalon","gants":"Gants","chaussures":"Chaussures","bottes":"Bottes","protection-chaussure":"Protège-chaussure","chaussette-chauffante":"Chaussettes chauffantes","gilet-chauffant":"Gilet chauffant","protection":"Protection","dorsale":"Dorsale","gilet-protection":"Gilet de protection","gilet-airbag":"Gilet airbag","ceinture":"Ceinture","sous-vetement":"Sous-vêtement technique","tour-de-cou":"Tour de cou","bandana":"Bandana","t-shirt":"T-shirt","sweat":"Sweat","casquette":"Casquette","lunettes":"Lunettes","masque":"Masque","ecran-masque":"Écran de masque","sac-a-dos":"Sac à dos","sacoche":"Sacoche","sacoche-jambe":"Sacoche de jambe","sacoche-reservoir":"Sacoche de réservoir","sacoche-cavaliere":"Sacoche cavalière","sacoche-portee":"Sac porté / bandoulière","sacoche-laterale":"Valise / sacoche latérale","top-case":"Top case","kit-fixation":"Kit de fixation","sac-equipement":"Sac d'équipement","antivol":"Antivol","bloque-disque":"Bloque-disque","chaine":"Chaîne antivol","antivol-u":"Antivol U","entretien-moto":"Entretien","lubrifiant":"Lubrifiant","nettoyant":"Nettoyant","outillage":"Outillage","chargeur-batterie":"Chargeur de batterie","tapis-moto":"Tapis de sol moto","phare":"Phare","feux-additionnels":"Feux additionnels","feu-arriere":"Feu arrière","eclairage":"Éclairage","guidon":"Guidon","poignee":"Poignée","accessoire-guidon":"Accessoire guidon","cale-pied":"Cale-pied","support-telephone":"Support téléphone","support-vignette":"Support vignette","housse-moto":"Housse moto","coussin-selle":"Coussin de selle","sangle":"Sangle","bulle":"Bulle / déflecteur","protege-reservoir":"Protège-réservoir","accessoire-moto":"Accessoire moto","bague":"Bague","bracelet":"Bracelet","porte-cles":"Porte-clés","cloche-moto":"Cloche (Guardian Bell)","plaque-deco":"Plaque déco","sticker":"Sticker"},"genre":{"homme":"Homme","femme":"Femme","unisexe":"Unisexe","enfant":"Enfant"},"saison":{"ete":"Été","mi-saison":"Mi-saison","hiver":"Hiver","4-saisons":"4 saisons"},"matiere":{"cuir":"Cuir","textile":"Textile","denim":"Denim","mesh":"Mesh (maille aérée)","softshell":"Softshell","polycarbonate":"Polycarbonate","abs":"ABS (coque de casque)","aramide":"Aramide","coton":"Coton","acier":"Acier","inox":"Inox","aluminium":"Aluminium","argent":"Argent (métal)"},"usage":{"route":"Route","urbain":"Urbain","sport":"Sport","touring":"Touring","pluie":"Pluie","cross":"Cross","enduro":"Enduro","tout-terrain":"Tout-terrain","aventure":"Aventure","atelier":"Atelier / garage","paddock":"Paddock","securite":"Sécurité","scooter":"Scooter"},"univers":{"bikers":"Bikers","entretien":"Entretien","radical":"Radical","urbain":"Urbain","touring":"Touring","adventure":"Adventure","heritage":"Héritage","racing":"Racing","casual":"Casual"},"certification":{"ece22-06":"ECE 22.06 (casques)","homologue-ce":"Homologué CE","en13594":"EN 13594 (gants)","en17092-aaa":"EN 17092 classe AAA","en17092-aa":"EN 17092 classe AA","en17092-a":"EN 17092 classe A","en17092-c":"EN 17092 classe C","en17092":"EN 17092 (classe non précisée)","en13634":"EN 13634 (bottes)","en1621-1-niveau1":"EN 1621-1 niv. 1 (coudes / genoux)","en1621-1-niveau2":"EN 1621-1 niv. 2 (coudes / genoux)","en1621-2-niveau1":"EN 1621-2 niv. 1 (dorsale)","en1621-2-niveau2":"EN 1621-2 niv. 2 (dorsale)","en1621-3-niveau1":"EN 1621-3 niv. 1 (pectorale)","en1621-3-niveau2":"EN 1621-3 niv. 2 (pectorale)","ce-niveau2":"CE niveau 2","sra":"SRA (antivols)","en1938":"EN 1938 (lunettes / masques)","fim":"FIM (tapis environnementaux)"},"equipement":{"bluetooth-ready":"Prêt Bluetooth","ecran-solaire":"Écran solaire","pinlock-ready":"Prêt Pinlock","fibershell":"Calotte fibre","lunettes-incluses":"Lunettes incluses","interieur-cuir":"Intérieur cuir","interieur-liege":"Intérieur liège","eyewear-ready":"Compatible lunettes de vue","ecran-tactile":"Compatible écran tactile (gants)"},"style":{"vintage":"Vintage","urban":"Urbain","graphique":"Graphique","cafe-racer":"Café racer","floral":"Floral","sport":"Sport","aventure":"Aventure","touring":"Touring"},"gamme":{"nox-helmets":"NOX Helmets","exklusiv":"EXKLUSIV"},"couleur":{"noir":"Noir","blanc":"Blanc","gris":"Gris","bleu":"Bleu","rouge":"Rouge","vert":"Vert","jaune":"Jaune","orange":"Orange","rose":"Rose","violet":"Violet","marron":"Marron","creme":"Crème / beige","kaki":"Kaki","bordeaux":"Bordeaux","argent":"Argent","or":"Or","multicolore":"Multicolore"}};
  var TITRES = EN ? {} : { matiere: 'Matière', equipement: 'Équipement', type_produit: 'Type de produit' };
  var ORDRE = { genre: 1, prix: 2, type_produit: 3, saison: 4, couleur: 5, marque: 6, matiere: 7 };
  var OUVERTS = { genre: true, prix: true, type_produit: true };
  var ORDRE_PLUS = 10;
  var mobile = window.matchMedia('(max-width: 1024px)');

  function pousser(evenement, donnees) {
    if (!variante) return;
    try {
      var o = { event: evenement, lpm_ab_test: 'filtres_mobile', lpm_ab_variante: variante };
      for (var k in donnees) o[k] = donnees[k];
      (window.dataLayer = window.dataLayer || []).push(o);
    } catch (e) {}
  }
  function clarity() {
    if (!variante) return;
    try { if (typeof window.clarity === 'function') window.clarity.apply(null, arguments); } catch (e) {}
  }
  // La classe d'Ella (collection-filters-form.js, chargé après ce fichier). Avant son chargement, le même nom désigne
  // le formulaire #CollectionFiltersForm (accès par id sur window) : on n'accepte que la classe.
  function trouverCFF() {
    try { return typeof CollectionFiltersForm === 'function' && CollectionFiltersForm.renderPage ? CollectionFiltersForm : null; } catch (e) { return null; }
  }

  // ---------- Mesure commune A / B ----------
  function initMesure(form) {
    pousser('lpm_ab_filtres', {});
    clarity('set', 'ab_filtres', variante);
    window.addEventListener('load', function () { clarity('set', 'ab_filtres', variante); });
    if (form) {
      form.addEventListener('change', function (e) {
        var c = e.target;
        if (!c || c.type !== 'checkbox') return;
        pousser('lpm_filtre', { lpm_filtre_source: 'panneau', lpm_filtre_groupe: (c.name || '').replace(/^filter\.(p\.m\.custom\.|p\.|v\.)/, ''), lpm_filtre_action: c.checked ? 'ajout' : 'retrait' });
        clarity('event', 'lpm_filtre_panneau_coche');
      });
    }
    document.addEventListener('click', function (e) {
      if (variante === 'A' && e.target.closest && e.target.closest('.toolbar [data-sidebar]')) {
        pousser('lpm_filtre_panneau', { lpm_filtre_source: 'bouton_filters' });
        clarity('event', 'lpm_filtre_panneau');
      }
    }, true);
  }

  // ---------- Variante B ----------
  function initB(form) {
    var grille = document.getElementById('CollectionProductGrid');
    var panneau = document.getElementById('halo-sidebar');
    var wrapper = form && form.querySelector('.facets__wrapper');
    var defil = panneau && panneau.querySelector('.halo-sidebar-wrapper');
    var CFF = trouverCFF();
    var etat = {};
    var plusOuvert = null;
    var plusBtn = null, voir = null, reset = null, obs = null;

    function slug(t) {
      return String(t || '').trim().toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
        .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
    }
    function majuscule(t) { return t.charAt(0).toUpperCase() + t.slice(1); }

    // Par le contenu : Ella recolle le contenu d'un filtre dans le bloc du même numéro, et les numéros glissent
    // quand un filtre disparaît (un bloc marqué « prix » peut alors contenir la gamme).
    function estPrix(b) { return !!b.querySelector('price-range, .facets__price'); }
    function cleFiltre(b) {
      if (estPrix(b)) return 'prix';
      var i = b.querySelector('input[name^="filter."]');
      if (!i) return '';
      var n = i.name, m = n.match(/^filter\.p\.m\.custom\.(.+)$/);
      if (m) return m[1];
      if (n === 'filter.p.product_type') return 'type_produit';
      if (n === 'filter.p.vendor') return 'marque';
      if (/^filter\.v\.option\.(couleur|color)/i.test(n)) return 'couleur';
      return n;
    }
    function nomFiltre(b) {
      var t = b.querySelector('.facets__text');
      return t ? t.textContent.replace(/\s+/g, ' ').trim() : '';
    }
    function nbActifs(b) {
      var n = b.querySelectorAll('input[type="checkbox"]:checked').length;
      if (estPrix(b)) {
        b.querySelectorAll('input[type="number"]').forEach(function (i) { if (i.getAttribute('value')) n++; });
      }
      return n;
    }
    function premierTexte(el) {
      for (var k = 0; k < el.childNodes.length; k++) {
        var c = el.childNodes[k];
        if (c.nodeType === 3 && c.nodeValue.trim()) return c;
      }
      return null;
    }
    function renommer(b, cle) {
      var table = LIBELLES[cle] || {};
      b.querySelectorAll('label.facet-checkbox, .facet-checkbox__text-label').forEach(function (l) {
        var noeud = premierTexte(l) || (l.querySelector('.text') && premierTexte(l.querySelector('.text')));
        if (!noeud) return;
        var brut = noeud.nodeValue.trim();
        var lib = table[slug(brut)];
        if (!lib && cle !== 'marque' && /^[a-z0-9]+(-[a-z0-9]+)+$/.test(brut)) lib = majuscule(brut.replace(/-/g, ' '));
        if (!lib && cle !== 'marque' && /^[a-zà-ÿ]/.test(brut)) lib = majuscule(brut);
        if (lib && lib !== brut) noeud.nodeValue = lib;
        var li = l.closest('li');
        if (cle === 'genre' && li) li.style.order = { femme: 1, homme: 2, unisexe: 3, enfant: 4 }[slug(lib || brut)] || 5;
      });
      var a = b.querySelector('.price-to-price');
      if (a && !EN) a.textContent = 'à';
      var titre = b.querySelector('.facets__text');
      var t = titre && premierTexte(titre);
      if (t && TITRES[cle] && t.nodeValue.trim() !== TITRES[cle]) t.nodeValue = TITRES[cle] + ' ';
    }
    function accordeon(b, cle) {
      var h = b.querySelector('.sidebarBlock-heading'), w = b.querySelector('.sidebarBlock-contentWrapper');
      if (!h || !w) return;
      var ouvert = Object.prototype.hasOwnProperty.call(etat, cle) ? etat[cle] : (!!OUVERTS[cle] || nbActifs(b) > 0);
      h.classList.toggle('is-clicked', ouvert);
      w.style.display = ouvert ? 'block' : 'none';
    }

    function decorer() {
      if (!wrapper) return;
      if (obs) obs.disconnect();
      // Filtre apparu après un rechargement : Ella l'ajoute au formulaire, hors du conteneur ordonné.
      Array.prototype.slice.call(form.children).forEach(function (b) {
        if (b.classList.contains('js-filter') && b.getAttribute('data-index') !== '0') wrapper.appendChild(b);
      });
      var sups = [], actifsSup = 0;
      Array.prototype.slice.call(wrapper.children).forEach(function (b, i) {
        if (!b.classList.contains('js-filter')) return;
        var cle = cleFiltre(b);
        b.setAttribute('data-lpm-cle', cle);
        var o = ORDRE[cle];
        b.style.order = o || (ORDRE_PLUS + 1 + (parseInt(b.getAttribute('data-index'), 10) || i));
        b.classList.toggle('lpm-fb-sup', !o);
        renommer(b, cle);
        accordeon(b, cle);
        if (!o) { sups.push(nomFiltre(b)); actifsSup += nbActifs(b); }
      });
      if (!plusBtn) {
        plusBtn = document.createElement('button');
        plusBtn.type = 'button';
        plusBtn.className = 'lpm-fb-plus';
        plusBtn.style.order = ORDRE_PLUS;
        plusBtn.innerHTML = '<span class="lpm-fb-plus-titre"></span><span class="lpm-fb-plus-liste"></span>'
          + '<svg class="lpm-fb-chevron" width="12" height="12" viewBox="0 0 10 10" aria-hidden="true"><path d="M1.5 3.5 5 7l3.5-3.5" fill="none" stroke="currentColor" stroke-width="1.6"/></svg>';
        plusBtn.querySelector('.lpm-fb-plus-titre').textContent = T.plus;
        plusBtn.addEventListener('click', function () {
          plusOuvert = !wrapper.classList.contains('lpm-fb-plus-ouvert');
          decorer();
        });
      }
      if (plusBtn.parentNode !== wrapper) wrapper.appendChild(plusBtn);
      plusBtn.hidden = !sups.length;
      plusBtn.querySelector('.lpm-fb-plus-liste').textContent = sups.join(', ');
      var ouvrir = plusOuvert === null ? actifsSup > 0 : plusOuvert;
      wrapper.classList.toggle('lpm-fb-plus-ouvert', ouvrir);
      plusBtn.setAttribute('aria-expanded', ouvrir ? 'true' : 'false');
      if (obs) obs.observe(form, { childList: true, subtree: true });
    }

    function majPied() {
      var barre = grille && grille.querySelector('[data-lpm-fb]');
      if (!barre || !voir) return;
      var n = parseInt(barre.getAttribute('data-total'), 10) || 0;
      var a = parseInt(barre.getAttribute('data-actifs'), 10) || 0;
      voir.textContent = n ? T.voir(n) : T.aucun;
      voir.classList.toggle('is-vide', !n);
      voir.classList.remove('is-charge');
      reset.hidden = !a;
    }
    function chargement() {
      if (!voir) return;
      voir.classList.add('is-charge');
      voir.textContent = T.maj;
    }
    function appliquer() {
      var fd = new FormData(form), p = new URLSearchParams();
      fd.forEach(function (v, k) { if (v !== '') p.append(k, v); });
      var q = p.toString();
      var el = form.closest('collection-filters-form');
      try { if (el && typeof el.onConvertPrice === 'function') q = el.onConvertPrice(q); } catch (e) {}
      CFF.renderPage(q, null);
    }
    function cases(param, vals) {
      return vals.map(function (v) {
        return form.querySelector('input[type="checkbox"][name="' + CSS.escape(param) + '"][value="' + CSS.escape(v) + '"]');
      });
    }
    function basculer(puce) {
      var param = puce.getAttribute('data-param') || '';
      var vals = (puce.getAttribute('data-valeurs') || '').split('||').filter(Boolean);
      var cs = form && CFF ? cases(param, vals) : [];
      if (!cs[0]) { window.location.href = puce.href; return; }
      var actif = puce.classList.contains('is-actif');
      var groupe = puce.getAttribute('data-groupe');
      if (!actif && groupe === 'genre') {
        form.querySelectorAll('input[type="checkbox"][name="' + CSS.escape(param) + '"]').forEach(function (c) { c.checked = false; });
        puce.parentNode.querySelectorAll('[data-groupe="genre"].is-actif').forEach(function (x) { x.classList.remove('is-actif'); });
      }
      cs.forEach(function (c) { if (c && (actif || !c.disabled)) c.checked = !actif; });
      puce.classList.toggle('is-actif', !actif);
      puce.setAttribute('aria-pressed', actif ? 'false' : 'true');
      appliquer();
      pousser('lpm_filtre', { lpm_filtre_source: 'puce', lpm_filtre_groupe: groupe, lpm_filtre_valeur: puce.textContent.trim(), lpm_filtre_action: actif ? 'retrait' : 'ajout' });
      clarity('event', 'lpm_filtre_puce');
    }
    function ouvrirPanneau(cible) {
      // Après la fin du clic : sinon le thème le prend pour un clic hors du panneau et le referme aussitôt.
      setTimeout(function () {
        var t = document.querySelector('.toolbar [data-sidebar]') || document.querySelector('[data-sidebar]');
        if (t) t.click(); else document.body.classList.add('open-mobile-sidebar');
        if (cible === 'prix') {
          etat.prix = true;
          decorer();
          var b = wrapper && wrapper.querySelector('[data-lpm-cle="prix"]');
          if (b && defil) setTimeout(function () { defil.scrollTop += b.getBoundingClientRect().top - defil.getBoundingClientRect().top - 8; }, 80);
        } else if (defil) {
          defil.scrollTop = 0;
        }
      }, 0);
      pousser('lpm_filtre_panneau', { lpm_filtre_source: cible === 'prix' ? 'puce_prix' : 'bouton_avances' });
      clarity('event', 'lpm_filtre_panneau');
    }
    function fermerPanneau() {
      var c = panneau && panneau.querySelector('[data-close-sidebar]');
      if (c) c.click(); else document.body.classList.remove('open-mobile-sidebar');
    }
    function allerAuxProduits() {
      var barre = grille && grille.querySelector('[data-lpm-fb]');
      if (!barre) return;
      var y = barre.getBoundingClientRect().top + window.pageYOffset - 72;
      if (Math.abs(window.pageYOffset - y) > 40) window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
    }

    // Puces, boutons de la barre, tri : délégués (la barre est redessinée à chaque filtre).
    document.addEventListener('click', function (e) {
      if (!mobile.matches || !e.target.closest) return;
      var puce = e.target.closest('[data-lpm-fb-puce]');
      if (puce) { e.preventDefault(); basculer(puce); return; }
      var o = e.target.closest('[data-lpm-fb-ouvrir]');
      if (o) { e.preventDefault(); ouvrirPanneau(o.getAttribute('data-lpm-fb-ouvrir')); }
    });
    document.addEventListener('change', function (e) {
      var s = e.target.closest && e.target.closest('[data-lpm-fb-tri]');
      if (!s) return;
      var sb = form && form.querySelector('#SortBy');
      pousser('lpm_tri', { lpm_tri: s.value });
      if (sb && CFF) { sb.value = s.value; appliquer(); return; }
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', s.value);
      u.searchParams.delete('page');
      window.location.href = u.toString();
    });

    if (!form || !wrapper || !panneau || !CFF) return;

    // Panneau : pied collant « Réinitialiser / Voir N produits ».
    var pied = document.createElement('div');
    pied.className = 'lpm-fb-pied';
    pied.innerHTML = '<button type="button" class="lpm-fb-reset"></button><button type="button" class="lpm-fb-voir"></button>';
    panneau.appendChild(pied);
    reset = pied.querySelector('.lpm-fb-reset');
    voir = pied.querySelector('.lpm-fb-voir');
    reset.textContent = T.reset;
    reset.addEventListener('click', function () {
      var sb = form.querySelector('#SortBy');
      etat = {};
      plusOuvert = null;
      CFF.renderPage(sb && sb.value ? 'sort_by=' + encodeURIComponent(sb.value) : '', null);
      pousser('lpm_filtre', { lpm_filtre_source: 'panneau', lpm_filtre_action: 'reinitialisation' });
    });
    voir.addEventListener('click', function () {
      var barre = grille.querySelector('[data-lpm-fb]');
      fermerPanneau();
      setTimeout(allerAuxProduits, 350);
      pousser('lpm_filtre_voir', { lpm_total: barre ? parseInt(barre.getAttribute('data-total'), 10) || 0 : 0 });
    });

    // « Appliquer » du prix : Ella applique le filtre (après 500 ms) mais laissait le panneau ouvert ; le client
    // recliquait plusieurs fois avant de trouver la croix (retour de Nico, 27/10). On ferme et on montre les produits.
    panneau.addEventListener('click', function (e) {
      if (!e.target.closest || !e.target.closest('#filter__price--apply, .filter__price--apply')) return;
      pousser('lpm_filtre', { lpm_filtre_source: 'panneau', lpm_filtre_groupe: 'prix', lpm_filtre_action: 'appliquer' });
      setTimeout(function () { fermerPanneau(); setTimeout(allerAuxProduits, 350); }, 0);
    });

    // Ouverture / fermeture des filtres choisie par le client : retenue malgré les rechargements d'Ella.
    wrapper.addEventListener('click', function (e) {
      var h = e.target.closest && e.target.closest('.sidebarBlock-heading');
      var b = h && h.closest('.js-filter');
      if (b) etat[b.getAttribute('data-lpm-cle')] = !h.classList.contains('is-clicked');
    }, true);
    form.addEventListener('input', function (e) {
      if (e.target && e.target.classList && e.target.classList.contains('filter__price')) return;
      chargement();
    });
    var rendre = CFF.renderPage;
    if (!CFF.lpmFiltres) {
      CFF.renderPage = function () { chargement(); return rendre.apply(CFF, arguments); };
      CFF.lpmFiltres = true;
    }

    panneau.classList.add('lpm-fb-panneau');
    obs = new MutationObserver(decorer);
    decorer();
    majPied();
    var liste = grille.querySelector('.collection');
    if (liste) new MutationObserver(majPied).observe(liste, { childList: true });
  }

  function demarrer() {
    if (!document.getElementById('CollectionProductGrid')) return;
    var form = document.getElementById('CollectionFiltersForm');
    if (!mobile.matches) return;
    initMesure(form);
    if (html.classList.contains('lpm-filtres-b')) initB(form);
  }
  // Après DOMContentLoaded : tous les scripts différés (dont celui d'Ella) ont alors été exécutés.
  if (document.readyState === 'complete') demarrer();
  else document.addEventListener('DOMContentLoaded', demarrer);
})();
